import React from "react";
import KeyValue from "../../shared/KeyValue";
import InputKeyValue from "../../shared/InputKeyValue";
import KeyDropdownValue from "../../shared/KeyDropdownValue";
import { User01 } from "../../normalizer";

const UserInfoEdit = (props) => {
  const { onEditSubmit, onChangeGender, onChange, ...user } = props;

  const handleChange = (e) => {
    e.preventDefault();
    const { firstName, lastName, phone, email, nif, gender } = e.currentTarget;
    onChange && onChange({
      first_name: firstName.value,
      last_name: lastName.value,
      phone: phone.value,
      email: email.value,
      nif: nif.value,
      gender: gender.value,
    });

  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const { firstName, lastName, phone, email, nif, gender } = e.target;

    onEditSubmit({
      first_name: firstName.value,
      last_name: lastName.value,
      phone: phone.value,
      email: email.value,
      nif: nif.value,
      gender: gender.value,
    });
  };

  const options = [
    {
      id: "female",
      name: "Feminino",
    },
    {
      id: "male",
      name: "Masculino",
    },
  ];
  let gender = user.gender;
  if (gender !== undefined) {
    gender = options.find((e) => user.gender === e.id);
  }

  const hasUserData = Boolean(
    user.first_name || user.last_name || user.phone || user.email || user.nif || user.gender
  );

  const firstNameField = (
    <div className="user-info-edit-column">
      <InputKeyValue
        title={"Primeiro nome"}
        placeholder="Insira o primeiro nome"
        defaultValue={user.first_name}
        name="firstName"
      />
    </div>
  );
  const lastNameField = (
    <div className="user-info-edit-column">
      <InputKeyValue
        title={"Apelido"}
        name="lastName"
        placeholder="Insira o apelido"
        defaultValue={user.last_name}
      />
    </div>
  );
  const genderField = (
    <div className="user-info-edit-column">
      <KeyDropdownValue
        title="Género"
        name="gender"
        defaultValue={gender}
        options={options}
        onChange={onChangeGender}
        leftIcon={<User01 />}
        rightIcon={<User01 />}
        placeholder="Selecione o género"
      />
    </div>
  );
  const emailField = (
    <div className="user-info-edit-column">
      <InputKeyValue
        title={"Email"}
        name="email"
        placeholder="exemplo@email.com"
        defaultValue={user.email}
      />
    </div>
  );
  const phoneField = (
    <div className="user-info-edit-column">
      <InputKeyValue
        title={"Telemóvel"}
        name="phone"
        placeholder="912345678"
        defaultValue={user.phone}
      />
    </div>
  );
  const nifField = (
    <div className="user-info-edit-column">
      <InputKeyValue
        title={"NIF"}
        name="nif"
        placeholder="NIF"
        defaultValue={user.nif}
      />
    </div>
  );
  const loginField = (
    <div className="user-info-edit-column">
      <InputKeyValue
        title={"Identificador"}
        name="login"
        disabled={true}
        defaultValue={user.login}
      />
    </div>
  );

  return (
    <form
      onChange={handleChange}
      onSubmit={handleSubmit}
      id="user-update-form"
      className="user-info-edit"
    >
      <div className="user-info-edit-row">
        {firstNameField}
        {lastNameField}
        {genderField}
      </div>
      {hasUserData ? (
        <div className="user-info-edit-row">
          {emailField}
          {phoneField}
          {nifField}
          {loginField}
        </div>
      ) : (
        <>
          <div className="user-info-edit-row">
            {emailField}
            {phoneField}
            <div className="user-info-edit-column"></div>
          </div>
          <div className="user-info-edit-row">
            {nifField}
            {loginField}
            <div className="user-info-edit-column"></div>
          </div>
        </>
      )}
    </form>
  );
};

export default UserInfoEdit;
